"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
const message_1 = require("./message");
class Event extends message_1.Message {
    constructor() {
        super(...arguments);
        /**
         * Orders events within an aggregate
         */
        this.sequence = -1;
    }
}
exports.Event = Event;
